import * as _ from 'lodash';
import A from './FeatureCreatorNewActions';
import {featureHasSelectedFilters} from "./FeaturesFilters/filtersFunctions";
import {FEATURES_SETUP_SET_FEATURE_GROUP} from "../../constants/actionTypes";
import {getCurrentFeatureToolSettings, isFeatureEnabled} from "../FeaturesSetup/featuresFunctions";
import {FEATURE_ENABLED_PROPERTIES} from "../FeaturesSetup/FeaturesSetupFeature/featureInterface";
import {applyFeatureMarkUp} from "../FeaturesSetup/FeaturesSetupMarkPopup/markUpFunctions";

const APPLY_TO_FEATURES = {
  Enabled: "Enabled",
  Disabled: "Disabled",
  All: "All"
};

const initialState = {
  hasKitchen: false,
  hasBathroom: false,
  loadingFeatures: false,
  activeFeaturesGroupName: null,
  enabledFeatures: [],
  enabledFeaturesIds: {},
  disabledFeatures: [],
  disabledFeaturesIds: {},
  term: '',
  activeMode: 'All',
  pendingFeatures: {},
  applyToFeatures: APPLY_TO_FEATURES.Enabled, // Enabled or All
  featuresRequestCount: 0
};

const shouldKeepEnabled = (unlinkedHideFrom, unlinkedHideFromQT, has, hasQT) =>
{
  let keepEnabled = false;
  if(unlinkedHideFrom !== null && !unlinkedHideFrom) {
    keepEnabled = true;
  }
  if(!keepEnabled && unlinkedHideFromQT !== null && !unlinkedHideFromQT) {
    keepEnabled = true;
  }
  if(!keepEnabled && unlinkedHideFrom === null && has) {
    keepEnabled = true;
  }
  if(!keepEnabled && unlinkedHideFromQT === null && hasQT) {
    keepEnabled = true;
  }
  return keepEnabled;
};

export default function (state = initialState, action) {
  switch (action.type) {
    case A.ActionTypes.loadFeaturesStart:
      return {
        ...state,
        loadingFeatures: true,
        activeFeaturesGroupName: action.payload.groupName,
        featuresRequestCount: ++state.featuresRequestCount
      };
    case FEATURES_SETUP_SET_FEATURE_GROUP:
      return {...state, activeFeaturesGroupName: action.payload.groupName};
    case A.ActionTypes.loadFeaturesEnd:
      if (!action.payload) {
        return {...state, loadingFeatures: false}
      }
      return setData(state, action.payload);
    case A.ActionTypes.resetFeatures:
      return Object.assign({}, state, {
        enabledFeatures: [],
        enabledFeaturesIds: {},
        disabledFeatures: [],
        disabledFeaturesIds: {}
      });
    case A.ActionTypes.updateFeatureData:
      return updateFeatureData(state, action.payload);
    case A.ActionTypes.cancelPendingChanges:
      return {...state, pendingFeatures: {}};
    case A.ActionTypes.enableAll:
      return enableAll(state, action.payload.enable, action.payload.property, action.payload.selectedFilters, action.payload.auth);
    case A.ActionTypes.lockAll:
      return lockAll(state, action.payload.lock, action.payload.selectedFilters);
    case A.ActionTypes.applyNewProperty:
      return _applyNewProperty(state, action.payload.propertyName, action.payload.propertyValue, action.payload.selectedFilters);
    case A.ActionTypes.setSearchTerm:
      return {...state, term: action.payload.term};
    case A.ActionTypes.setMode:
      return {...state, activeMode: action.payload.mode};
    case A.ActionTypes.toggleApplyToFeatures:
      const applyToFeatures = state.applyToFeatures === APPLY_TO_FEATURES.Enabled
        ? APPLY_TO_FEATURES.Disabled
        : state.applyToFeatures === APPLY_TO_FEATURES.Disabled
          ? APPLY_TO_FEATURES.All
          : APPLY_TO_FEATURES.Enabled
      return {...state, applyToFeatures: applyToFeatures};
  }

  return state;
}


function updateFeatureData(state, {id, propName, propValue, isFromEnabled}) {
  const {
    pendingFeatures, enabledFeatures, enabledFeaturesIds,
    disabledFeaturesIds, disabledFeatures
  } = state;
//console.log(state, id, propName, propValue, isFromEnabled);
  pendingFeatures[id] = {...pendingFeatures[id], [propName]: propValue};

  if (isFromEnabled) {
    enabledFeatures[enabledFeaturesIds[id]][propName] = propValue;
  } else {
    disabledFeatures[disabledFeaturesIds[id]][propName] = propValue;
  }
//console.log(enabledFeatures[enabledFeaturesIds[id]]);
  return {...state, pendingFeatures, enabledFeatures, disabledFeatures};
}

export function setData(state, payload) {
  const {enabledFeatures, disabledFeatures} = payload; // also it has auth obj props

  const eKeys = {};
  const dKeys = {};

  const allFeatures = [...(enabledFeatures || []), ...(disabledFeatures || [])];

  let realEnabled = [];
  let realDisabled = [];

  for (let i = 0; i < allFeatures.length; i++) {
    let feature = allFeatures[i];

    if (!feature.price) {
      feature.price = 0;
    } else if (feature.price.toString().includes('.')) {
      feature.price = feature.price.toFixed(2);
    }

    if (feature.markUpLogic) {
      feature = applyFeatureMarkUp(feature);
    }

    const keepEnabled = isFeatureEnabled(feature, payload);

    if (keepEnabled) {
      eKeys[feature.featureDefinitionId] = realEnabled.length;
      realEnabled.push(feature);
    } else {
      dKeys[feature.featureDefinitionId] = realDisabled.length;
      realDisabled.push(feature);
    }
  }

  // const realEnabled = [...enabledFeatures, ...disabledFeatures].filter(dbFeature => ["hasKv", "hasQt", "hasBv", "hasBvQt"].some(prop => dbFeature[prop]));
  // const realDisabled = [...enabledFeatures, ...disabledFeatures].filter(dbFeature => ["hasKv", "hasQt", "hasBv", "hasBvQt"].every(prop => !dbFeature[prop]));

  return {
    ...state,
    enabledFeatures: realEnabled,
    disabledFeatures: realDisabled,
    enabledFeaturesIds: eKeys,
    disabledFeaturesIds: dKeys,
    loadingFeatures: false
  };
}

function enableAll(state, enable, property, selectedFilters = [], auth) {
  let {enabledFeatures, disabledFeatures, pendingFeatures, applyToFeatures} = state;
  const setter = (feature, prop, newValue) => {
    if (FEATURE_ENABLED_PROPERTIES.some(x => x === prop)) {
      let featureShouldBeUpdated = false;
      let toolSettings = getCurrentFeatureToolSettings(feature);
      const forTool = ((prop === "hasKv" || prop === "hasQt") ? "kitchen" : "bathroom");
      const toolProperty = ((prop === "hasKv" || prop === "hasBv") ? "enableVisualizer" : "enableQuotingTool");
      if (!toolSettings.some(setting => setting.tool === forTool)) { // should not ever access here, but let it be
        toolSettings.push({
          tool: forTool,
          enableVisualizer: false,
          enableQuotingTool: false
        });
      }
      toolSettings = toolSettings.map(setting => {
        if (setting.tool === forTool && (setting[toolProperty] !== newValue)) {
          featureShouldBeUpdated = true;
          return Object.assign({}, setting, {[toolProperty]: newValue})
        }
        return setting
      });
      if (!featureShouldBeUpdated) {
        return feature
      }
      prop = "toolSettings";
      newValue = toolSettings;
    }
    if (feature.unlinkedData) {
      feature.unlinkedData = Object.assign({}, feature.unlinkedData, {[prop]: newValue});
      pendingFeatures[feature.featureDefinitionId] = {
        ...pendingFeatures[feature.featureDefinitionId],
        unlinkedData: {...feature.unlinkedData},
        unlinkedDataJson: JSON.stringify({[feature.featureDefinitionId]: {...feature.unlinkedData}})
      }
    } else {
      feature[prop] = newValue;
      pendingFeatures[feature.featureDefinitionId] = {
        ...pendingFeatures[feature.featureDefinitionId],
        [prop]: newValue
      };
    }
    return feature;
  };
  const changeFeaturesArray = (featuresArray) => {
    return featuresArray.map(dbFeature => {
      if (!selectedFilters.length || featureHasSelectedFilters(dbFeature, selectedFilters)) {
        dbFeature = setter(dbFeature, property, enable);
        const newEnabled = isFeatureEnabled(dbFeature, auth);
        if (dbFeature.enabled !== newEnabled) {
          dbFeature = setter(dbFeature, 'enabled', newEnabled);
        }
      }
      return dbFeature
    });
  };
  if (applyToFeatures === APPLY_TO_FEATURES.All || applyToFeatures === APPLY_TO_FEATURES.Enabled) {
    enabledFeatures = changeFeaturesArray(enabledFeatures);
  }
  if (applyToFeatures === APPLY_TO_FEATURES.All || applyToFeatures === APPLY_TO_FEATURES.Disabled) {
    disabledFeatures = changeFeaturesArray(disabledFeatures);
  }
  return {...state, enabledFeatures, disabledFeatures, pendingFeatures};
}

function lockAll(state, lock, selectedFilters = []) {
  let {enabledFeatures, disabledFeatures, pendingFeatures, applyToFeatures} = state;
  const changeFeaturesArray = (featuresArray) => {
    return featuresArray.map(dbFeature => {
      if ((!selectedFilters.length || featureHasSelectedFilters(dbFeature, selectedFilters))
        && dbFeature.unlocked !== lock) {
        dbFeature.unlocked = lock;
        pendingFeatures[dbFeature.featureDefinitionId] = {
          ...pendingFeatures[dbFeature.featureDefinitionId],
          unlocked: lock
        };
      }
      return dbFeature
    });
  };
  if (applyToFeatures === APPLY_TO_FEATURES.All || applyToFeatures === APPLY_TO_FEATURES.Enabled) {
    enabledFeatures = changeFeaturesArray(enabledFeatures);
  }
  if (applyToFeatures === APPLY_TO_FEATURES.All || applyToFeatures === APPLY_TO_FEATURES.Disabled) {
    disabledFeatures = changeFeaturesArray(disabledFeatures);
  }
  return {...state, enabledFeatures, disabledFeatures, pendingFeatures};
}

function _applyNewProperty(state, propertyName, propertyValue, selectedFilters = []) {
  let {enabledFeatures, disabledFeatures, pendingFeatures, applyToFeatures} = state;
  const changeFeaturesArray = (featuresArray) => {
    return featuresArray.map(dbFeature => {
      if ((!selectedFilters.length || featureHasSelectedFilters(dbFeature, selectedFilters))
        && dbFeature[propertyName] !== propertyValue) {
        dbFeature[propertyName] = propertyValue;
        pendingFeatures[dbFeature.featureDefinitionId] = {
          ...pendingFeatures[dbFeature.featureDefinitionId],
          [propertyName]: propertyValue
        };
      }
      return dbFeature
    });
  };
  if (applyToFeatures === APPLY_TO_FEATURES.All || applyToFeatures === APPLY_TO_FEATURES.Enabled) {
    enabledFeatures = changeFeaturesArray(enabledFeatures);
  }
  if (applyToFeatures === APPLY_TO_FEATURES.All || applyToFeatures === APPLY_TO_FEATURES.Disabled) {
    disabledFeatures = changeFeaturesArray(disabledFeatures);
  }
  return {...state, enabledFeatures, disabledFeatures, pendingFeatures};
}
